import { render, staticRenderFns } from "./BudgetSummaryStrip.vue?vue&type=template&id=2b5bef03&scoped=true"
import script from "./BudgetSummaryStrip.vue?vue&type=script&lang=js"
export * from "./BudgetSummaryStrip.vue?vue&type=script&lang=js"
import style0 from "./BudgetSummaryStrip.vue?vue&type=style&index=0&id=2b5bef03&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5bef03",
  null
  
)

export default component.exports